<template>
    <section class="depoist_fund border-0 max-1440 p-0">
        <alert-notification v-if="notification_msg != ''"/>
        <!-- <div class="section_title">
            <h5>Whitelisted IP Address</h5>
        </div> -->
        <div  class="modal fade review" :class="(Object.keys(deleteBank).length > 0)? 'show' : ''" v-if="Object.keys(deleteBank).length > 0">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">Delete Payment Detail</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="deleteBank = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <app-delete-bank :bankData="deleteBank" :pageNameData="'bankList'"></app-delete-bank>
                    </div>
                </div>
            </div>
        </div>

        <div  class="modal fade review" :class="(Object.keys(editBank).length > 0)? 'show' : ''" v-if="Object.keys(editBank).length > 0">
            <div class="modal-dialog modal-dialog-centered max-800" role="document">
                <div class="modal-content">
                    <div class="p-4 border-bottom modal-header bg-none">
                        <h4 class="mb-0">Update Payment Detail</h4>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="editBank = {}">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body px-4">
                        <app-edit-bank :bankData="editBank" :pageNameData="'bankList'"></app-edit-bank>
                    </div>
                </div>
            </div>
        </div>
        <div class="border position-relative border-radius-15 mt-4">
                    <div class="marketData table-responsive">
                        <table class="table table-striped border-0">
                            <thead>
                                <tr>
                                    <th>Bank Name</th>
                                    <th>Account Number</th>
                                    <th>Beneficiary Name</th>
                                    <th>Bank Address</th>
                                    <th>Status</th>
                                    <th>Created</th>
                                    <th>Action</th>
                                </tr>
                            </thead>
                            <!-- v-if="index >= (page - 1)*pageLimit && index < page*pageLimit" -->
                            <tbody v-if="getBankData.totalRecords > 0">
                                <tr v-for="(val,index) in getBankData.records" >
                                    <td>{{val.bank_name}}</td>
                                    <td>{{val.account_no}}</td>
                                    <td>{{val.beneficiary_name}}</td>
                                    <td>{{val.bank_address}}</td>
                                    <td>{{$env_var.bankStatus[parseInt(val.status)]}}</td>
                                    <td>{{formatDate(val.created)}}</td>
                                    <td>
                                        <a class="t_ic" href="#" @click.prevent="deleteBank = val"><feather type="x-circle"></feather></a>
                                        <a class="t_ic" href="#" @click.prevent="viewTicket(val.trans_id)"><feather type="eye"></feather></a>
                                    </td>
                                </tr>
                            </tbody>
                            <table-loader :pageloader_value="pageLoader" :type="'table'" :colspan="'7'" :listLength="getBankData.totalRecords" v-else></table-loader>
                        </table>
                    </div>
                    <pagination :totalRecords="getBankData.totalRecords" :limit="pageLimit" :pageNo="page" v-if="getBankData.totalRecords > parseInt(pageLimit)"></pagination>
                </div>
    </section>
</template>
<script>
import { depositWithdrawalMixins } from "@/plugins/depositWithdrawal";
import { Const } from "@/plugins/vue-provider-cache/const.mod";
import tradingMixins from "@/plugins/trading";
import appDeleteBank from "./delete-bank";
import appEditBank from "./edit-bank";
export default {
    name: 'Ip-List',
	mixins: [depositWithdrawalMixins, tradingMixins],
    data(){
        return {
            pageLoader: false,
            notification_msg:'',
            notification_type:'',
            page : '1',
            pageLimit : '10',
            deleteBank : {},
            editBank : {}
        }
    },
    components: {
        appDeleteBank, appEditBank
    },
    watch: {
        // deleteBank(value) {
        //     if(value != '' && Object.keys(value).length > 0){
        //         document.body.classList.add('modalBody')
        //     }else{
        //         document.body.classList.remove('modalBody')
        //     }
        // }
    },
    methods: {
        viewTicket(listId){
            this.$router.push({name: 'view' , query: { 'id':listId}})
        },
        listing() {
            let json = {
                globalParams: {
                    "filter": {},
                    "sort": [],
                    "search": "",
                    "page": this.page,
                    "perPage": this.pageLimit
                },
                localParams: { parameter: this },
            }
            this._runGetBankDetails(json);
        }
    },
    created(){
		this.listing()
    }
}
</script>


// WEBPACK FOOTER //
// src/components/website/bank/bank-list.vue